import useStyles from './styles';
import { useHeaderState } from '@/hooks/useHeaderState';
import { HeaderLeft } from '@/sections/Header/HeaderLeft/HeaderLeft';
import { HeaderRight } from '@/sections/Header/HeaderRight/HeaderRight';

interface HeaderProps {
  onSettingsClick?: () => void;
  hideBack?: boolean;
}

export const Header = ({ onSettingsClick, hideBack }: HeaderProps) => {
  const classes = useStyles();
  const {
    screen,
    isAuthorized,
    showBackButton,
    showGenerationsButton,
    handleBack,
    handleGenerationsClick,
    handleCloseApp,
    handleLogin,
    getMobileTitle,
  } = useHeaderState();

  return (
    <header className={classes.header}>
      <HeaderLeft
        screen={screen}
        showBackButton={hideBack ? false : showBackButton}
        mobileTitle={getMobileTitle()}
        onBack={handleBack}
      />
      <HeaderRight
        isAuthorized={isAuthorized}
        showGenerationsButton={showGenerationsButton}
        onLogin={handleLogin}
        onGenerationsClick={handleGenerationsClick}
        onCloseApp={handleCloseApp}
        onSettingsClick={onSettingsClick}
      />
    </header>
  );
};

export default Header;
